import React from 'react';

import classNames from 'classnames';

import './index.scss';

const VARIANTS = {
  /** TITLES */
  TITLE_GIGANTIC: 'title-gigantic',
  TITLE_ENORMOUS: 'title-enormous',
  TITLE_HUGE: 'title-huge',
  TITLE_BIG: 'title-big',
  TITLE_MEDIUM: 'title-medium',
  TITLE_NORMAL: 'title-normal',
  TITLE_SMALL: 'title-small',
  TITLE_TINY: 'title-tiny',
  TITLE_MICRO: 'title-micro',
  TITLE_MINUSCULE: 'title-minuscule',
  /** TEXTS */
  TEXT_HUGE: 'text-huge',
  TEXT_BIG: 'text-big',
  TEXT_NORMAL: 'text-normal',
  TEXT_SMALL: 'text-small',
  TEXT_TINY: 'text-tiny',
  /** CARDS */
  CARD_TITLE_BIG: 'card-title-big',
  CARD_TITLE_NORMAL: 'card-title-normal',
  CARD_TITLE_SMALL: 'card-title-small',
  CARD_TAG_FAT: 'card-tag-fat',
  CARD_TAG_THIN: 'card-tag-thin',
  CARD_TAG_MICRO: 'card-tag-micro',
  MINICARD_SUBTITLE: 'minicard-subtitle',
  /** PIONS */
  PION_TITLE: 'pion-title',
  PION_TITLE_FAT: 'pion-title-fat',
  /** OTHER */
  CAPS_BIG: 'caps-big',
  CAPS_SMALL: 'caps-small',
} as const;

export type TypographyPropsType = React.HTMLProps<HTMLDivElement> & {
  component?: any; // TODO: correct type would be  keyof HTMLElementTagNameMap but it needs more investigation
  variant: (typeof VARIANTS)[keyof typeof VARIANTS];
};

const Typography = ({
  component: Component = 'span',
  variant = 'text-big',
  ...props
}: TypographyPropsType) => {
  return (
    <Component {...props} className={classNames(variant, props.className)}>
      {props.children}
    </Component>
  );
};

Typography.THEME = {
  VARIANTS,
};

export default Typography;
